import AxiosPermisos  from './../axiosPermisos'

import {
  path
} from './path'

async function getSetting () {
  return await AxiosPermisos.get(path.settings, true)
}

async function getCustomize () {
  return await AxiosPermisos.get(path.customize, true)
}

async function getCustomizeValues( { value } ) {
  return await AxiosPermisos.get(`${path.customize_values}/${value}`, true)
}

export {
  getSetting,
  getCustomize,
  getCustomizeValues
}